import {TrackingWishlistItemId} from '../../../types';

export const trackWishlist = (wishlistItems: TrackingWishlistItemId[]) => {
  const event = {
    event: 'wishlist',
    wishlist: wishlistItems,
  };
  return event;
};
